import { PlaceBadget } from '@/components/PlaceBadget';
import { VariableModel } from '@/lib/model';
import * as React from 'react';
import './index.scss';
import { Variable } from './Variable';

export interface DemoVarsProps {
  collegeName: string;
  fillColor: string;
  variables: VariableModel[];
  positionMessage: string;
}

export const DemoVars: React.FC<DemoVarsProps> = ({
  collegeName,
  fillColor,
  variables,
  positionMessage,
}) => (
  <div className="DemoVars">
    <div className="DemoVars__header">
      <PlaceBadget fillColor={fillColor} collegeName={collegeName} />
      <p>{positionMessage}</p>
    </div>
    <div className="DemoVars__variables">
      {variables.map((v, i) => (
        <Variable fillColor={fillColor} {...v} key={i.toString()} />
      ))}
    </div>
    <p className="DemoVars__information">
      La barra grigia più chiara rappresenta il dato nazionale
    </p>
  </div>
);
